module.exports = __webpack_public_path__ + "static/media/BrixSans-ExtraLight.01b9e450.ttf";